var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.54287C0 11.5304 1.6125 13.1429 3.6 13.1429H12.8C14.5675 13.1429 16 11.7104 16 9.94287C16 8.39537 14.9 7.10287 13.44 6.80787C13.5425 6.54037 13.6 6.24787 13.6 5.94287C13.6 4.61787 12.525 3.54287 11.2 3.54287C10.7075 3.54287 10.2475 3.69287 9.8675 3.94787C9.175 2.74787 7.8825 1.94287 6.4 1.94287C4.19 1.94287 2.4 3.73287 2.4 5.94287C2.4 6.01037 2.4025 6.07787 2.405 6.14537C1.005 6.63787 0 7.97287 0 9.54287Z",
    fill: "#bbbbbb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDisabled);
export default __webpack_public_path__ + "static/media/cloud_disabled.1c9182fd00f09899e52da87a26afd020.svg";
export { ForwardRef as ReactComponent };